// Generated by purs version 0.13.8
"use strict";
var Data_Maybe = require("../Data.Maybe/index.js");
var React_Basic = require("../React.Basic/index.js");
var React_Basic_Native_Generated = require("../React.Basic.Native.Generated/index.js");
var React_Basic_Native_PropTypes = require("../React.Basic.Native.PropTypes/index.js");
var React_Basic_Native_Styles = require("../React.Basic.Native.Styles/index.js");
var React_Basic_Native_Styles_Flex = require("../React.Basic.Native.Styles.Flex/index.js");
var React_Basic_Native_Styles_Text = require("../React.Basic.Native.Styles.Text/index.js");
var ZAP_Dart_Client_Screens_Utils = require("../ZAP.Dart.Client.Screens.Utils/index.js");
var sheet = {
    input: React_Basic_Native_Styles.staticStyles([ React_Basic_Native_Styles_Flex.justifyContent(React_Basic_Native_PropTypes.center(React_Basic_Native_Styles_Flex.jcCenter)), React_Basic_Native_Styles_Text.fontSize(18), React_Basic_Native_Styles.width(React_Basic_Native_Styles.intWidth)(255), React_Basic_Native_Styles.paddingVertical(React_Basic_Native_Styles.intPaddingVertical)(6), React_Basic_Native_Styles.margin(React_Basic_Native_Styles.intMargin)(8), React_Basic_Native_Styles_Flex.alignItems(React_Basic_Native_PropTypes.center(React_Basic_Native_Styles_Flex.flexAlignmentCenter)), React_Basic_Native_Styles_Flex.alignSelf(React_Basic_Native_PropTypes.center(React_Basic_Native_Styles_Flex.flexAlignmentCenter)), React_Basic_Native_Styles.borderBottomWidth(1) ])
};
var component = React_Basic.createComponent("LineInput");
var lineInput = (function () {
    var render = function (props) {
        return React_Basic_Native_Generated.textInput()({
            style: React_Basic_Native_Styles["styles'"]([ sheet.input, React_Basic_Native_Styles.styles([ React_Basic_Native_Styles_Text.color(props.color), React_Basic_Native_Styles.borderBottomColor(props.color) ]) ]),
            value: Data_Maybe.fromMaybe("")(props.value),
            onChangeText: function ($0) {
                return props.onChangeText(ZAP_Dart_Client_Screens_Utils.getNonEmpty($0))();
            }
        });
    };
    return React_Basic.makeStateless(component)(render);
})();
module.exports = {
    lineInput: lineInput
};
